var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseTextIndentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93436 2.31564C2.7635 2.14479 2.48648 2.14479 2.31562 2.31564C2.14476 2.4865 2.14476 2.7635 2.31562 2.93436L3.7563 4.375L2.31562 5.81564C2.14476 5.9865 2.14476 6.2635 2.31562 6.43436C2.48648 6.60521 2.7635 6.60521 2.93436 6.43436L4.6844 4.68436C4.85526 4.5135 4.85526 4.2365 4.6844 4.06564L2.93436 2.31564Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56263 2.62469C6.321 2.62469 6.12512 2.82056 6.12512 3.06219C6.12512 3.30381 6.321 3.49969 6.56263 3.49969H11.8128C12.0544 3.49969 12.2503 3.30381 12.2503 3.06219C12.2503 2.82056 12.0544 2.62469 11.8128 2.62469H6.56263Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56263 5.24969C6.321 5.24969 6.12512 5.44556 6.12512 5.68719C6.12512 5.92881 6.321 6.12469 6.56263 6.12469H11.8128C12.0544 6.12469 12.2503 5.92881 12.2503 5.68719C12.2503 5.44556 12.0544 5.24969 11.8128 5.24969H6.56263Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18751 7.87469C1.94588 7.87469 1.75 8.07056 1.75 8.31219C1.75 8.55381 1.94588 8.74969 2.18751 8.74969H11.8128C12.0544 8.74969 12.2503 8.55381 12.2503 8.31219C12.2503 8.07056 12.0544 7.87469 11.8128 7.87469H2.18751Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18751 10.4997C1.94588 10.4997 1.75 10.6956 1.75 10.9372C1.75 11.1788 1.94588 11.3747 2.18751 11.3747H11.8128C12.0544 11.3747 12.2503 11.1788 12.2503 10.9372C12.2503 10.6956 12.0544 10.4997 11.8128 10.4997H2.18751Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseTextIndentIcon);
export default __webpack_public_path__ + "static/media/increaseTextIndentIcon.e16f103edb6abf24a81c2bda2eb33850.svg";
export { ForwardRef as ReactComponent };